<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/pegawai-list-custom">Daftar Pegawai</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Riwayat Pendidikan
        </li>
      </ol>
    </nav>

    <div class="content-block">
      <h5>Daftar Riwayat Pendidikan</h5>
    </div>
    <LogPopupTemplate ref="logPopup" />
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          :focused-row-enabled="true"
          ref="dataGrid"
          :data-source="pendidikanListStore.dataSourcePendidikanList"
          :allow-column-reordering="true"
          :show-borders="true"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @exporting="onExporting"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :filter-value="filterValue"
          :filter-sync-enabled="true"
          :remote-operations="true"
          :scrolling="{
            mode: 'virtual',
            rowRenderingMode: 'virtual',
            columnRenderingMode: 'virtual',
            useNative: true,
          }"
          @context-menu-preparing="onContextMenuPreparing"
        >
          <DxHeaderFilter :visible="true" />

          <DxScrolling mode="virtual" />
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxPager
            :visible="true"
            :showPageSizeSelector="false"
            :showNavigationButtons="false"
            :show-info="true"
            :infoText="'Page {0} of {1} ({2} items)'"
          />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" />
          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
          />
          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('dataGrid')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <DxColumnFixing :enabled="true" />
          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="pegawai_id"
            data-type="number"
            caption="Opsi"
            :allow-exporting="false"
            :allow-edititng="false"
            :allow-filtering="false"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="getOptions(data)"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>
          <!-- <DxColumn
            caption="pegawaiID"
            data-field="pegawai_id"
            data-type="number"
          /> -->

          <DxColumn
            caption="#"
            data-field="row_number"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :fixed="true"
            fixed-position="left"
            data-type="number"
          />

          <DxColumn
            data-field="riwayat_pendidikans_id"
            caption="ID"
            :fixed="true"
            fixed-position="left"
            :allowHeaderFiltering="false"
            :visible="false"
          >
          </DxColumn>

          <DxColumn
            data-field="simpeg_pegawais_nik"
            caption="NIK"
            :fixed="true"
            fixed-position="left"
            :allowHeaderFiltering="false"
          >
          </DxColumn>
          <DxColumn
            data-field="simpeg_pegawais_nama"
            caption="Nama"
            :fixed="true"
            fixed-position="left"
            :allowHeaderFiltering="false"
            :min-width="200"
          >
          </DxColumn>
          <DxColumn
            dataField="status_aktifs_nama"
            caption="Status Aktif"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.statusAktifSource }"
          />
          <DxColumn
            data-field="status_penyesuaian"
            caption="Status Penyesuaian"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.statusPenyesuaianSource }"
            cell-template="penyesuaianTemplate"
          >
          </DxColumn>
          <DxColumn
            data-field="tgl_penyesuaian"
            caption="Tgl Penyesuaian"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allowHeaderFiltering="false"
          />

          <DxColumn
            data-field="pendidikan_jenjangs_nama"
            caption="Jenjang Pendidikan"
            :allowHeaderFiltering="true"
            :header-filter="{
              dataSource: commonStore.getPendidikanJenjangSource().value,
            }"
          />
          <DxColumn
            data-field="institusi"
            caption="Institusi"
            :allowHeaderFiltering="false"
          />
          <DxColumn
            data-field="fakultas"
            caption="Fakultas"
            :allowHeaderFiltering="false"
          />
          <DxColumn
            data-field="jurusan"
            caption="Jurusan"
            :allowHeaderFiltering="false"
          />
          <DxColumn
            data-field="ipk"
            caption="IPK"
            :allowHeaderFiltering="false"
          />
          <DxColumn
            data-field="tahun_mulai"
            caption="Tahun Mulai"
            :allowHeaderFiltering="false"
            data-type="number"
          />
          <DxColumn
            data-field="tahun_lulus"
            caption="Tahun Lulus"
            :allowHeaderFiltering="false"
            data-type="number"
          />
          <DxColumn
            data-field="ijazah_no"
            caption="No. Ijazah"
            :allowHeaderFiltering="false"
          />
          <DxColumn
            data-field="ijazah_tgl"
            caption="Tgl Ijazah"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allowHeaderFiltering="false"
          />

          <DxColumn
            :allowHeaderFiltering="false"
            :allow-filtering="false"
            :allow-sorting="true"
            :allow-exporting="false"
            :allow-editing="false"
            :allow-adding="false"
            cell-template="fileTemplate"
            caption="Dokumen"
            data-field="file_path"
            data-type="string"
          />

          <DxColumn
            caption="Dibuat oleh"
            :allowHeaderFiltering="false"
            data-field="created_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <DxColumn
            caption="Diubah oleh"
            :allowHeaderFiltering="false"
            data-field="updated_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <template #fileTemplate="{ data }">
            <div class="small-button-container">
              <DxButton
                :visible="setPrintAdaFile(data.text)"
                @click="
                  commonFunction.handleClickDocument(
                    data,
                    data.data.simpeg_pegawais_nama +
                      ' - File Riwayat Pendidikan',
                  )
                "
                icon="download"
              />
            </div>
          </template>
          <template #penyesuaianTemplate="{ data }">
            {{ displayPenyesuaian(data) }}
          </template>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<script>
import LogPopupTemplate from "./LogPopupTemplate.vue";
import * as commonFunction from "@/utils/common-function.js";
import { BASE_URL } from "@/global-constants";
import { usePendidikanListStore } from "@/stores/views/pendidikan-list-store";
import { useCommonStore } from "@/stores/utility/common-store2";
import { confirm } from "devextreme/ui/dialog";
import can from "@/haspermission";

import DxButton from "devextreme-vue/button";
import _ from "lodash";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
  DxButton as DxButtonDatagrid,
  DxSummary,
  DxTotalItem,
  DxHeaderFilter,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";

/* eslint-disable */
export default {
  components: {
    LogPopupTemplate,
    confirm,
    DxTextBox,
    DxDateBox,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxButton,
    DxButtonDatagrid,

    DxPopup,
    DxToolbarItem,
    DxItem,
    DxDropDownButton,

    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxHeaderFilter,
  },
  setup() {
    const pendidikanListStore = usePendidikanListStore();
    const commonStore = useCommonStore();
    pendidikanListStore.dataSourcePendidikanList.filter(null);
    return {
      pendidikanListStore,
      commonStore,
      commonFunction,
    };
  },
  data() {
    const vm = this;
    return {
      serverUrl: `${BASE_URL}/`,
      fileUrl: null,
      filterValue: [],

      stylingMode: "underlined",
      //outlined, filled, underlined
      labelMode: "floating",

      numberingPageSize: 100,
      buttonFilterPintasanVisible: false,
    };
  },

  async created() {
    await this.commonStore.preloadStores();
  },

  async mounted() {
    this.pendidikanListStore.initialized;
    // await this.commonStore.preloadStores();
  },

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  methods: {
    getOptions(data) {
      return [
        {
          text: "Detail Pegawai",
          pegawai_id: data.data.pegawai_id,
          row_key: data.key,
        },
        {
          text: "Absensi",
          pegawai_id: data.data.pegawai_id,
          row_key: data.key,
        },
        {
          text: "Riwayat Gaji",
          pegawai_id: data.data.pegawai_id,
          row_key: data.key,
        },
        {
          text: "Log Perubahan Data",
          pegawai_id: data.data.pegawai_id,
          row_key: data.key,
        },
        // other options...
      ];
    },
    displayPenyesuaian(e) {
      if (e.data.status_penyesuaian) return "Penyesuaian";
      return "";
    },
    setPrintAdaFile(e) {
      if (_.isEmpty(e)) return false;
      else return true;
    },

    hilangFilter() {
      // this.absenStore.onMuatButtonClick();
      this.buttonFilterPintasanVisible = false;
    },
    onContextMenuPreparing(e) {
      console.log("onContextMenuPreparing", e);
      if (e.target == "content") {
        e.itemData = {
          pegawai_id: e.row.data.pegawai_id,
          row_key: e.row.data.id,
        };

        // e.items can be undefined
        if (e.row.isEditing) return;
        if (!e.items) e.items = [];
        e.items.push({
          text: "Lihat Detail Pegawai",
          icon: "user",
          onItemClick: () => {
            e.itemData.text = "Detail Pegawai";
            this.onItemClick(e);
          },
        });

        e.items.push({
          text: "Lihat Absensi",
          icon: "event",
          onItemClick: () => {
            e.itemData.text = "Absensi";
            this.onItemClick(e);
          },
        });

        e.items.push({
          text: "Riwayat Gaji",
          icon: "money",
          onItemClick: () => {
            e.itemData.text = "Riwayat Gaji";
            this.onItemClick(e);
          },
        });
        e.items.push({
          text: "Log Perubahan Data",
          icon: "clock",
          onItemClick: () => {
            e.itemData.text = "Log Perubahan Data";
            this.$refs.logPopup.showBySubject(e.row.key, "RiwayatPendidikan");
          },
        });
      }
    },
    onItemClick(e) {
      console.log("onItemClick ", e);
      const pegawaiId = e.itemData.pegawai_id;
      const rowKey = e.itemData.row_key;

      if (e.itemData.text === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: { filter: ["absen_bulans_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData.text === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData.text === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "pegawai-detail-custom",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }
      if (e.itemData.text === "Log Perubahan Data") {
        this.$refs.logPopup.showBySubject(rowKey, "RiwayatPendidikan");
      }
    },
    resetFilter() {
      this.filterValue = [];

      this.$refs["dataGrid"].instance.getDataSource().reload();
    },

    can,

    refreshDatagrid(gridRef) {
      // this.$refs[gridRef].instance.clearFilter();
      this.$refs[gridRef].instance.getDataSource().reload();
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Absen");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Riwayat Pendidikan.xlsx",
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
